const clamp = (value) => Math.max(0, Math.min(1, value));

export function solutionCardProgress(progress, index) {
  const t = clamp((progress - index * 0.055) / 0.18);
  return t * t * (3 - 2 * t);
}

// Move through the logo during the hero, then slow down in the space behind it
// while the four solution panels appear. Continue the journey in later chapters.
export function journeyDepth(scrollY, start, end, pageEnd, crossing) {
  const arrival = crossing + 10;
  if (scrollY <= start) return clamp(scrollY / Math.max(1, start)) * arrival;
  if (scrollY <= end)
    return arrival + clamp((scrollY - start) / Math.max(1, end - start)) * 8;
  return (
    arrival +
    8 +
    clamp((scrollY - end) / Math.max(1, pageEnd - end)) * (128 - arrival - 8)
  );
}
